import { Theme, useTheme } from '@mui/material'

export const useMinimalsTheme = (): Theme => {
  return useTheme()
}
